import {
  AnalyticsSessionok9n7iyuxvoj as AnalyticsSession,
  IAnalyticsAccessor8msxm7d2po53 as IAnalyticsAccessor,
  IAnalyticsMutator1o33d6dg8g9hg as IAnalyticsMutator,
  IAnalyticsEventTracker3dt8wr4gltex1 as IAnalyticsEventTracker,
  AnalyticsEventTrackerk8518ys1zbmt as AnalyticsEventTracker,
} from './Shared7Punches-domain-analytics-domain.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  Unit_instance104q5opgivhr8 as Unit_instance,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Result3t1vadv16kmzk as Result,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  CancellationException3b36o9qz53rgr as CancellationException,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  Unitkvevlwgzwiuc as Unit,
  isInterface3d6p8outrmvmk as isInterface,
  getValue48kllevslyh6 as getValue,
  equals2au1ep9vhcato as equals,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  emptyList1g2z5xcrvp2zy as emptyList,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  StringSerializer_getInstance1k1oz5j50sfik as StringSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  serializer1hwzc6m64v1op as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  LIST_getInstance3iji3zetpdcxm as LIST_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  SimpleValueEndpointCacheStrategy2snxed6lorji8 as SimpleValueEndpointCacheStrategy,
  Companion_instance38at02i5wbrbj as Companion_instance_0,
  UnexpectedApiResponse11rd45rhjxm6r as UnexpectedApiResponse,
  SimpleCacheLocalSource3mbicvk11uh40 as SimpleCacheLocalSource,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
  IEnvironmentProvider2spq4fpbokmem as IEnvironmentProvider,
} from './Shared7Punches-common-base.mjs';
import {
  Companion_getInstance35hsivaslc5e3 as Companion_getInstance,
  ApiVersion_APRIL_2026_getInstance1y3s521mv7m63 as ApiVersion_APRIL_2026_getInstance,
  buildV2Path1ie1ylvss3rsk as buildV2Path,
  mapApiErrorResponse18m737xo6p7hy as mapApiErrorResponse,
  get_sharedJson2ja82jrdlkmvt as get_sharedJson,
  Clientssjxb7gh2u6y as Client,
} from './Shared7Punches-infrastructure-network.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
  headers24pki7ce1busg as headers,
  HttpStatement3zxb33q8lku as HttpStatement,
} from './ktor-ktor-client-ktor-client-core.mjs';
import {
  Application_getInstance1d4ly18wdhadx as Application_getInstance,
  contentType1lwcfjsjo0z8g as contentType,
  Companion_getInstancepumzx9q4106p as Companion_getInstance_0,
} from './ktor-ktor-http.mjs';
import {
  JsonElementf07o4p6p57al as JsonElement,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from './ktor-ktor-utils.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance_1,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  TypeQualifier1esmq2h0dalsb as TypeQualifier,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { ICache3bwileb79diof as ICache } from './Shared7Punches-infrastructure-cache.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiAnalyticsSession, 'ApiAnalyticsSession', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForFunctionReference(SimpleCacheLocalSource$put$ref, VOID, VOID, [1]);
initMetadataForLambda(AnalyticsRepository$cacheStrategy$slambda, CoroutineImpl, VOID, [0]);
initMetadataForClass(AnalyticsRepository, 'AnalyticsRepository', VOID, VOID, [IAnalyticsAccessor, IAnalyticsMutator], [1]);
initMetadataForInterface(IAnalyticsRemoteSource, 'IAnalyticsRemoteSource', VOID, VOID, VOID, [0, 1]);
initMetadataForCoroutine($getSessionCOROUTINE$1, CoroutineImpl);
initMetadataForClass(AnalyticsRemoteSource, 'AnalyticsRemoteSource', VOID, VOID, [IAnalyticsRemoteSource], [0, 1]);
//endregion
function toDomain(_this__u8e3s4) {
  return new AnalyticsSession(_this__u8e3s4.j9z_1);
}
function Companion() {
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.analytics.data.model.ApiAnalyticsSession', this, 1);
  tmp0_serialDesc.wy('id', false);
  this.k9z_1 = tmp0_serialDesc;
}
protoOf($serializer).l9z = function (encoder, value) {
  var tmp0_desc = this.k9z_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.zs(tmp0_desc, 0, value.j9z_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.l9z(encoder, value instanceof ApiAnalyticsSession ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.k9z_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.ur(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.ur(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiAnalyticsSession_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer).xn = function () {
  return this.k9z_1;
};
protoOf($serializer).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function ApiAnalyticsSession_init_$Init$(seen0, id, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance().k9z_1);
  }
  $this.j9z_1 = id;
  return $this;
}
function ApiAnalyticsSession_init_$Create$(seen0, id, serializationConstructorMarker) {
  return ApiAnalyticsSession_init_$Init$(seen0, id, serializationConstructorMarker, objectCreate(protoOf(ApiAnalyticsSession)));
}
function ApiAnalyticsSession(id) {
  this.j9z_1 = id;
}
protoOf(ApiAnalyticsSession).toString = function () {
  return 'ApiAnalyticsSession(id=' + this.j9z_1 + ')';
};
protoOf(ApiAnalyticsSession).hashCode = function () {
  return getStringHashCode(this.j9z_1);
};
protoOf(ApiAnalyticsSession).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiAnalyticsSession))
    return false;
  var tmp0_other_with_cast = other instanceof ApiAnalyticsSession ? other : THROW_CCE();
  if (!(this.j9z_1 === tmp0_other_with_cast.j9z_1))
    return false;
  return true;
};
function SimpleCacheLocalSource$put$ref($boundThis) {
  this.m9z_1 = $boundThis;
}
protoOf(SimpleCacheLocalSource$put$ref).n9z = function (p0, $completion) {
  return this.m9z_1.m2u(p0, $completion);
};
protoOf(SimpleCacheLocalSource$put$ref).h9 = function (p1, $completion) {
  return this.n9z(p1 instanceof AnalyticsSession ? p1 : THROW_CCE(), $completion);
};
function SimpleCacheLocalSource$put$ref_0($boundThis) {
  var i = new SimpleCacheLocalSource$put$ref($boundThis);
  var l = function (p0, $completion) {
    return i.n9z(p0, $completion);
  };
  l.callableName = 'put';
  l.$arity = 1;
  return l;
}
function AnalyticsRepository$cacheStrategy$slambda(this$0, resultContinuation) {
  this.w9z_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(AnalyticsRepository$cacheStrategy$slambda).x9z = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(AnalyticsRepository$cacheStrategy$slambda).ma = function ($completion) {
  return this.x9z($completion);
};
protoOf(AnalyticsRepository$cacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.w9z_1.y9z_1.ba0(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(AnalyticsRepository$cacheStrategy$slambda).m32 = function (completion) {
  return new AnalyticsRepository$cacheStrategy$slambda(this.w9z_1, completion);
};
function AnalyticsRepository$cacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new AnalyticsRepository$cacheStrategy$slambda(this$0, resultContinuation);
  var l = function ($completion) {
    return i.x9z($completion);
  };
  l.$arity = 0;
  return l;
}
function AnalyticsRepository$cacheStrategy$lambda(it) {
  return toDomain(it);
}
function AnalyticsRepository(remoteSource, localSource) {
  this.y9z_1 = remoteSource;
  this.z9z_1 = localSource;
  var tmp = this;
  var tmp_0 = this.z9z_1.n18();
  var tmp_1 = SimpleCacheLocalSource$put$ref_0(this.z9z_1);
  var tmp_2 = AnalyticsRepository$cacheStrategy$slambda_0(this, null);
  tmp.aa0_1 = new SimpleValueEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, AnalyticsRepository$cacheStrategy$lambda);
}
function IAnalyticsRemoteSource() {
}
function AnalyticsRemoteSource$getSession$lambda($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $getSessionCOROUTINE$1(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.ka0_1 = _this__u8e3s4;
}
protoOf($getSessionCOROUTINE$1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          var tmp_0 = this;
          tmp_0.la0_1 = this.ka0_1.ca2_1;
          var tmp_1 = this;
          tmp_1.ma0_1 = 'analytics/identify';
          var tmp_2 = this;
          tmp_2.na0_1 = ApiVersion_APRIL_2026_getInstance();
          this.oa0_1 = this.la0_1;
          this.pa0_1 = this.ma0_1;
          this.qa0_1 = this.na0_1;
          this.o8_1 = 2;
          var tmp_3 = this;
          tmp_3.sa0_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.ta0_1 = this.oa0_1.f6l_1;
          var tmp_5 = this;
          tmp_5.ua0_1 = buildV2Path(this.oa0_1, this.pa0_1);
          this.va0_1 = this.ta0_1;
          this.wa0_1 = this.ua0_1;
          var tmp_6 = this;
          tmp_6.xa0_1 = this.va0_1;
          this.ya0_1 = this.xa0_1;
          var tmp_7 = this;
          tmp_7.za0_1 = this.ya0_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.wa0_1);
          contentType(this_0, Application_getInstance().c3v_1);
          headers(this_0, AnalyticsRemoteSource$getSession$lambda(this.qa0_1));
          tmp_8.aa1_1 = this_0;
          this.ba1_1 = this.za0_1;
          this.ca1_1 = this.aa1_1;
          this.ca1_1.q4r_1 = Companion_getInstance_0().g41_1;
          var tmp_9 = this;
          tmp_9.da1_1 = this.ba1_1;
          var tmp_10 = this;
          tmp_10.ea1_1 = this.ca1_1;
          this.fa1_1 = this.da1_1;
          this.ga1_1 = this.ea1_1;
          this.n8_1 = 1;
          suspendResult = (new HttpStatement(this.ga1_1, this.fa1_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.ha1_1 = suspendResult;
          var tmp_11 = this;
          this.sa0_1;
          var value = this.ha1_1;
          tmp_11.ra0_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 12;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 12;
          var tmp_12 = this.q8_1;
          if (tmp_12 instanceof CancellationException) {
            this.ia1_1 = this.q8_1;
            var tmp_13 = this;
            throw this.ia1_1;
          } else {
            var tmp_14 = this.q8_1;
            if (tmp_14 instanceof Error) {
              this.ja1_1 = this.q8_1;
              var tmp_15 = this;
              var exception = this.ja1_1;
              tmp_15.ra0_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 3;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          this.o8_1 = 12;
          this.ka1_1 = this.ra0_1;
          this.la1_1 = this.ka1_1;
          this.ma1_1 = Result__exceptionOrNull_impl_p6xea9(this.la1_1);
          if (this.ma1_1 == null) {
            var tmp_16 = this;
            var tmp_17 = _Result___get_value__impl__bjfvqg(this.la1_1);
            tmp_16.oa1_1 = (tmp_17 == null ? true : !(tmp_17 == null)) ? tmp_17 : THROW_CCE();
            this.pa1_1 = this.oa1_1;
            var tmp_18 = this;
            tmp_18.qa1_1 = this.pa1_1;
            this.ra1_1 = this.qa1_1;
            this.sa1_1 = this.ra1_1.c4u().z43_1;
            var containsArg = this.sa1_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 8;
              var tmp_19 = this;
              tmp_19.va1_1 = Companion_instance;
              if (getKClass(ApiAnalyticsSession).equals(getKClass(Unit))) {
                var tmp_20 = this;
                tmp_20.xa1_1 = this.ra1_1;
                this.ya1_1 = this.xa1_1;
                this.n8_1 = 6;
                var tmp_21 = this.ya1_1.y4u();
                var tmp_22 = getKClass(ApiAnalyticsSession);
                var tmp_23;
                try {
                  tmp_23 = createKType(getKClass(ApiAnalyticsSession), arrayOf([]), false);
                } catch ($p) {
                  var tmp_24;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_24 = null;
                  } else {
                    throw $p;
                  }
                  tmp_23 = tmp_24;
                }
                suspendResult = tmp_21.a4u(new TypeInfo(tmp_22, tmp_23), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_25 = this;
                tmp_25.za1_1 = this.ra1_1;
                this.aa2_1 = this.za1_1;
                this.n8_1 = 5;
                var tmp_26 = this.aa2_1.y4u();
                var tmp_27 = getKClass(JsonElement);
                var tmp_28;
                try {
                  tmp_28 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_29;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_29 = null;
                  } else {
                    throw $p;
                  }
                  tmp_28 = tmp_29;
                }
                suspendResult = tmp_26.a4u(new TypeInfo(tmp_27, tmp_28), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_30 = this;
              tmp_30.ba2_1 = Companion_instance;
              this.n8_1 = 4;
              suspendResult = mapApiErrorResponse(this.ra1_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_31 = this;
            var it = this.ma1_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_31.na1_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 11;
            continue $sm;
          }

        case 4:
          var tmp4 = suspendResult;
          var tmp_32 = this;
          this.ba2_1;
          tmp_32.ta1_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 10;
          continue $sm;
        case 5:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_33 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiAnalyticsSession), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_34;
            if (tmp2 instanceof JsonObject) {
              tmp_34 = tmp2.c3p('data');
            } else {
              tmp_34 = false;
            }
            if (tmp_34) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_35;
              if (dataValue instanceof JsonObject) {
                tmp_35 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_35 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_35 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_35;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_33.wa1_1 = tmp$ret$0;
          this.n8_1 = 7;
          continue $sm;
        case 6:
          var tmp_36 = this;
          tmp_36.wa1_1 = suspendResult instanceof ApiAnalyticsSession ? suspendResult : THROW_CCE();
          this.n8_1 = 7;
          continue $sm;
        case 7:
          var tmp1 = this.wa1_1;
          var tmp_37 = this;
          this.va1_1;
          tmp_37.ua1_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 12;
          this.n8_1 = 9;
          continue $sm;
        case 8:
          this.o8_1 = 12;
          var tmp_38 = this.q8_1;
          if (tmp_38 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_39 = this;
            throw e_0;
          } else {
            var tmp_40 = this.q8_1;
            if (tmp_40 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_41 = this;
              tmp_41.ua1_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 9;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 9:
          this.o8_1 = 12;
          var tmp_42 = this;
          var this_2 = this.ua1_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_43;
          if (exception_1 == null) {
            var tmp_44 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_44 == null ? true : !(tmp_44 == null)) ? tmp_44 : THROW_CCE();
            tmp_43 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_43 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_42.ta1_1 = tmp_43.ul_1;
          this.n8_1 = 10;
          continue $sm;
        case 10:
          this.na1_1 = new Result(this.ta1_1);
          this.n8_1 = 11;
          continue $sm;
        case 11:
          return this.na1_1;
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 12) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function AnalyticsRemoteSource(apiClient) {
  this.ca2_1 = apiClient;
}
protoOf(AnalyticsRemoteSource).ba0 = function ($completion) {
  var tmp = new $getSessionCOROUTINE$1(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function get_analyticsModule() {
  _init_properties_AnalyticsModule_kt__7g7gyo();
  return analyticsModule;
}
var analyticsModule;
function analyticsModule$lambda($this$module) {
  _init_properties_AnalyticsModule_kt__7g7gyo();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = analyticsModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IAnalyticsRemoteSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp4 = new TypeQualifier(getKClass(AnalyticsSession));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = analyticsModule$lambda$lambda_0;
  var scopeQualifier_0 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Singleton_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(SimpleCacheLocalSource), tmp4, definition, kind_0, secondaryTypes_0);
  var factory_0 = new SingleInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_0);
  }
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = analyticsModule$lambda$lambda_1;
  var scopeQualifier_1 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Singleton_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(AnalyticsRepository), null, definition_0, kind_1, secondaryTypes_1);
  var factory_1 = new SingleInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_1);
  }
  var tmp = new KoinDefinition($this$module, factory_1);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$13 = [getKClass(IAnalyticsAccessor), getKClass(IAnalyticsMutator)];
  binds(tmp, tmp$ret$13);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_1 = analyticsModule$lambda$lambda_2;
  var scopeQualifier_2 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Singleton_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(IAnalyticsEventTracker), null, definition_1, kind_2, secondaryTypes_2);
  var factory_2 = new SingleInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_2);
  }
  new KoinDefinition($this$module, factory_2);
  return Unit_instance;
}
function analyticsModule$lambda$lambda($this$factory, it) {
  _init_properties_AnalyticsModule_kt__7g7gyo();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new AnalyticsRemoteSource(tmp$ret$0);
}
function analyticsModule$lambda$lambda_0($this$single, it) {
  _init_properties_AnalyticsModule_kt__7g7gyo();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleCacheLocalSource('analytics_session', tmp$ret$0);
}
function analyticsModule$lambda$lambda_1($this$single, it) {
  _init_properties_AnalyticsModule_kt__7g7gyo();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IAnalyticsRemoteSource), null, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(AnalyticsSession));
  var tmp$ret$2 = $this$single.q1d(getKClass(SimpleCacheLocalSource), qualifier, null);
  return new AnalyticsRepository(tmp, tmp$ret$2);
}
function analyticsModule$lambda$lambda_2($this$single, it) {
  _init_properties_AnalyticsModule_kt__7g7gyo();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IAnalyticsAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$single.q1d(getKClass(IAnalyticsMutator), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_1 = $this$single.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$3 = $this$single.q1d(getKClass(IEnvironmentProvider), null, null);
  return new AnalyticsEventTracker(tmp, tmp_0, tmp_1, tmp$ret$3);
}
var properties_initialized_AnalyticsModule_kt_mwzy2q;
function _init_properties_AnalyticsModule_kt__7g7gyo() {
  if (!properties_initialized_AnalyticsModule_kt_mwzy2q) {
    properties_initialized_AnalyticsModule_kt_mwzy2q = true;
    analyticsModule = module_0(VOID, analyticsModule$lambda);
  }
}
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
//endregion
//region block: init
Companion_instance_1 = new Companion();
//endregion
//region block: exports
export {
  get_analyticsModule as get_analyticsModule1tajkb9krkps0,
};
//endregion

